const comHeader = (() => {
  if (document.querySelector("header.crevia-common.header") !== null) {



    ScrollTrigger.create({
      trigger: 'body', //アニメーションが始まるトリガーとなる要素
      start: '1% 0%',
      end: '100% 0%',
      toggleClass: { targets: "header.crevia-common.header", className: "is-bg" }, //クラスをつけたり、外したりできる
    });



  }
})();
export default comHeader;